import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { Button, message, Input, Card, InputNumber, Typography, Tag, Form, Select, Col, Row, Table } from 'antd';
import { SEARCH_ITEM_COL, TABLE_DATA_DEFAULT } from '@/scripts/config';
import { createJsonOptions } from '@/scripts/utils';
// import useSearchList from '@/hooks/useSearchList';
import dayjs from 'dayjs';
import { Log } from '@icon-park/react';

const pageKey = 'BaseList'; //页面身份
export default function GoAccountList() {
    const [dataSource, setState] = useState([]);
    const [count, setCount] = useState(2);
    const [shipList, setShipList] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const [form] = Form.useForm();
    useEffect(() => {
        loading();
        ajax.get('/shippingLine')
            .then((response) => {
                const shipList = response;
                setShipList(shipList);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const loading = () => {
        ajax.get('/basePort')
            .then((response) => {
                const data = response.map((item) => {
                    if (item.UNCode === null) {
                        item.UNCode = '';
                    }
                    // if (item.shippingline != null) {
                    //     item.shippingline = item.shippingline.split(',');
                    // }
                    return item;
                });
                data.sort((a, b) => a?.id - b?.id);
                setState(data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const EditableCell = ({ editing, dataIndex, inputTypeSelect, title, inputType, record, index, children, ...restProps }) => {
        const form = Form.useFormInstance();
        let inputNode;
        if (inputType === 'number') {
            inputNode = <InputNumber />;
        } else if (inputTypeSelect === 'select') {
            inputNode = (
                <Select
                    mode="multiple"
                    onChange={handleChange}
                    style={{ width: 180 }}
                    options={createJsonOptions(shipList)}
                    showSearch
                    allowClear
                ></Select>
            );
        } else {
            if (dataIndex === 'cityName') {
                inputNode = (
                    <Input
                        onChange={(e) => {
                            const upperValue = e.target.value.toUpperCase();
                            form.setFieldsValue({ [dataIndex]: upperValue });
                        }}
                    />
                );
            } else {
                inputNode = <Input />;
            }
        }

        return (
            <td>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    const isEditing = (record) => record.id === editingKey;

    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    const edit = (record) => {
        if (record.shippingline) {
            record.shippingline = record.shippingline.split(',');
        }
        form.setFieldsValue({
            id: record.id,
            cityName: record.cityName,
            countryCode: record.countryCode,
            countryGeoId: record.countryGeoId,
            countryName: record.countryName,
            maerskGeoLocationId: record.maerskGeoLocationId,
            maerskRkstCode: record.maerskRkstCode,
            UNCode: record.UNCode,
            shippingline: record.shippingline,
            ...record,
        });

        setEditingKey(record.id);
    };

    // 新增
    const handleAdd = (record) => {
        let idArr = [];
        dataSource.forEach((item) => {
            idArr.push(item.id);
        });
        const idMax = idArr.reduce((a, b) => Math.max(a, b), 0);
        const newData = {
            add: 0,
            id: '',
            cityName: '',
            countryCode: '',
            countryGeoId: '',
            countryName: '',
            maerskGeoLocationId: '',
            maerskRkstCode: '',
            UNCode: '',
            shippingline: null,
            ...record,
        };
        form.setFieldsValue(newData);
        setEditingKey(newData.id);
        setState([newData, ...dataSource]);
        setCount(newData.id);
    };

    const save = async (id) => {
        try {
            const row = await form.validateFields();
            const newData = [...dataSource];
            const index = newData.findIndex((item) => id === item.id);
            if (newData[index].add == 0) {
                // 新增保存
                let params = {
                    ...row,
                    id: Number(row.id),
                };

                if (params.shippingline) {
                    params.shippingline = params.shippingline.join(',');
                }
                if (params.cityName === '' || params.countryCode === '' || params.countryGeoId === '') {
                    message.error('数据不能为空');
                    return;
                } else {
                    ajax.post('/addBasePort', params)
                        .then((response) => {
                            // newData.push(params);
                            // setData(newData);
                            delete newData[index].add;
                            setEditingKey('');
                            loading();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            } else {
                // 保存
                const item = [index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                    id: Number(row.id),
                });

                let params = newData[item];
                if (Array.isArray(params.shippingline)) {
                    params.shippingline = params.shippingline.join(',');
                }
                if (params.cityName === '' || params.countryCode === '' || params.countryGeoId === '') {
                    message.error('数据不能为空');
                    return;
                } else {
                    ajax.post('/basePort', params)
                        .then((response) => {
                            // newData.push(params);
                            // setData(newData);
                            setEditingKey('');
                            loading();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            }
            setEditingKey('');
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            editable: true,
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: 'cityName',
            dataIndex: 'cityName',

            sorter: (a, b) => a['cityName'].localeCompare(b['cityName']),
            editable: true,
        },
        {
            title: 'countryCode',
            dataIndex: 'countryCode',

            sorter: (a, b) => a['countryCode'].localeCompare(b['countryCode']),
            editable: true,
        },
        {
            title: 'countryGeoId',
            dataIndex: 'countryGeoId',

            sorter: (a, b) => a['countryGeoId'].localeCompare(b['countryGeoId']),
            editable: true,
        },
        {
            title: 'countryName',
            dataIndex: 'countryName',

            sorter: (a, b) => a['countryName'].localeCompare(b['countryName']),
            editable: true,
        },
        {
            title: 'maerskGeoLocationId',
            dataIndex: 'maerskGeoLocationId',

            sorter: (a, b) => a['maerskGeoLocationId'].localeCompare(b['maerskGeoLocationId']),
            editable: true,
        },
        {
            title: 'maerskRkstCode',
            dataIndex: 'maerskRkstCode',

            sorter: (a, b) => a['maerskRkstCode'].localeCompare(b['maerskRkstCode']),
            editable: true,
        },
        {
            title: 'UNCode',
            dataIndex: 'UNCode',

            sorter: (a, b) => a['UNCode'].localeCompare(b['UNCode']),
            editable: true,
        },
        {
            title: 'shippingline',
            dataIndex: 'shippingline',
            editable: true,
        },
        {
            title: '操作',
            width: 80,
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => save(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            保存
                        </Typography.Link>
                        {/* <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                            <a href="#">Cancel</a>
                        </Popconfirm> */}
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        修改
                    </Typography.Link>
                );
            },
        },
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ? 'number' : col.dataIndex === 'origincity_name' ? 'select' : 'text',
                inputTypeSelect: col.dataIndex === 'shippingline' ? 'select' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    return (
        <div className="list">
            <PageHeader title="基础端口列表" sticky></PageHeader>
            {/* <Card className="ax-table-card">{renderTable()}</Card> */}
            <Form form={form} component={false}>
                <Button
                    onClick={handleAdd}
                    type="primary"
                    style={{
                        marginBottom: 16,
                    }}
                >
                    新增一行
                </Button>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    className="List"
                    bordered
                    rowKey={(record) => record.id}
                    pagination={false}
                    dataSource={dataSource}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                />
            </Form>
        </div>
    );
}
